
import React from 'react';
import { Twitter, Linkedin, Facebook } from 'lucide-react';
import Logo from '../../assets/images/gurukullogo.png';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="w-full p-12 footer-homepage-container">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-3 gap-y-8 md:gap-8 py-10 max-w-sm mx-auto sm:max-w-3xl lg:max-w-full">
                    <div className="col-span-full mb-10 lg:col-span-2 lg:mb-0">
                        <a href="/" className="flex justify-center lg:justify-start">
                            <img src={Logo} alt="Finhaat Logo" className="h-10 w-auto" />
                        </a>
                        <p className="py-8 text-sm text-gray-500 lg:max-w-xs text-center lg:text-left">
                            Finhaat is a marketplace for financial services distribution that seeks to connect the customer to the solution provider.
                        </p>
                        <a href="https://finhaat.com/contact-us/" className="py-2.5 px-5 h-9 block w-fit bg-indigo-600 rounded-full shadow-sm text-xs text-white mx-auto transition-all duration-500 hover:bg-indigo-700 lg:mx-0">
                            Contact us
                        </a>
                    </div>

                    <div className="lg:mx-auto text-left">
                        <h4 className="text-lg text-gray-900 font-medium mb-7">Quick Links</h4>
                        <ul className="text-sm transition-all duration-500">
                            <li className="mb-6"><a href="https://finhaat.com/our-story/" className="text-gray-600 hover:text-gray-900">Our Story</a></li>
                            <li className="mb-6"><a href="https://finhaat.com/products/savings/" className="text-gray-600 hover:text-gray-900">Savings</a></li>
                            <li><a href="https://finhaat.com/public-disclosures/" className="text-gray-600 hover:text-gray-900">Public Disclosures</a></li>
                        </ul>
                    </div>

                    <div className="lg:mx-auto text-left">
                        <h4 className="text-lg text-gray-900 font-medium mb-7">Company</h4>
                        <ul className="text-sm transition-all duration-500">
                            <li className="mb-6"><a href="https://finhaat.com/team/" className="text-gray-600 hover:text-gray-900">Team</a></li>
                            <li className="mb-6"><a href="https://finhaat.com/life-at-finhaat/" className="text-gray-600 hover:text-gray-900">Life at Finhaat</a></li>
                            <li><a href="https://finhaat.com/partners/" className="text-gray-600 hover:text-gray-900">Partners</a></li>
                        </ul>
                    </div>

                </div>

                <div className="py-7 border-t border-gray-200">
                    <div className="flex items-center justify-center flex-col lg:justify-between lg:flex-row">
                        <span className="text-sm text-gray-500">©<a href="https://finhaat.com/">finhaat</a> 2024, All rights reserved.</span>
                        <div className="flex mt-4 space-x-4 sm:justify-center lg:mt-0">

                            <a href="https://www.linkedin.com/company/finhaat-a-financial-institution/" className="w-8 h-8 rounded-full transition-all duration-500 flex justify-center items-center bg-[linear-gradient(45deg,#0077B5_0%,#0077B5_100%)] hover:bg-gradient-to-b from-gray-900 to-gray-900">
                                <Linkedin size={20} color="white" />
                            </a>
                            <a href="https://x.com/finhaat" className="w-8 h-8 rounded-full transition-all duration-500 flex justify-center items-center bg-[#33CCFF] hover:bg-gray-900">
                                <Twitter size={20} color="white" />
                            </a>


                            <a href="https://www.facebook.com/finhaatfinance" className="w-8 h-8 rounded-full transition-all duration-500 flex justify-center items-center bg-[#337FFF] hover:bg-gray-900">
                                <Facebook size={16} color="white" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
